import { ForwardedRef, forwardRef } from 'react';
import { ICommonFormProps } from '../DynamicForm.types';
import { isFormValidationError } from '@src/utilities/form';
import { Input } from '@src/components/ui';
import { InputRef } from 'antd';
import { INPUT_CONFIG } from '@src/constants/inputConfig';

const ALLOWED_KEYS = [
    'Backspace',
    'Delete',
    'ArrowLeft',
    'ArrowRight',
    'Tab',
    ' ',
];
const VALID_CHAR_REGEX = /^[A-Za-z0-9\s-]*$/; // letters, numbers, space, dash

export const FormZipCode = forwardRef(
    (props: ICommonFormProps, ref: ForwardedRef<InputRef>) => {
        const { size, ...inputProps } = props.inputProperties || {};

        const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
            const key = e.key;

            if (ALLOWED_KEYS.includes(key)) {
                inputProps.onKeyDown?.(e);
                return;
            }

            if (!VALID_CHAR_REGEX.test(key)) {
                e.preventDefault();
            }

            inputProps.onKeyDown?.(e);
        };

        return (
            <div className="w-full">
                <Input
                    className={`h-10 text-base ${props.className ?? ''}`}
                    ref={ref}
                    disabled={props.disabled || false}
                    label={props.label}
                    error={
                        props.errors
                            ? isFormValidationError(props.errors.type)
                                ? props.errors?.message
                                : `${props.label} ${props.errors.type}`
                            : undefined
                    }
                    data-component-name={props.keyName}
                    {...inputProps}
                    size={size}
                    placeholder={
                        props.inputProperties?.placeholder || 'Enter zip code'
                    }
                    type="text"
                    {...props.field}
                    onChange={
                        props.formProps?.onChange ?? props.field?.onChange
                    }
                    onBlur={props.formProps?.onBlur ?? props.field?.onBlur}
                    isRequired={
                        typeof props.registerOptions?.required === 'object'
                            ? Boolean(props.registerOptions.required.value)
                            : Boolean(props.registerOptions?.required)
                    }
                    maxLength={
                        props.formProps?.maxLength ??
                        INPUT_CONFIG.ZIP_CODE.maxLength
                    }
                    minLength={
                        props.formProps?.minLength ??
                        INPUT_CONFIG.ZIP_CODE.minLength
                    }
                    showCount={props.formProps?.showCount}
                    addonBefore={props.formProps?.addonBefore}
                    addonAfter={props.formProps?.addonAfter}
                    help={props.formProps?.help}
                    onKeyDown={handleKeyDown}
                />
            </div>
        );
    }
);

FormZipCode.displayName = 'FormZipCode';
